/**
 * Entry point for mybswhealth.
 */

// ---------------------------------------------------------
// polyfills for IE: order matters; keep them in this order.
import "@babel/polyfill";
import "core-js";
import "whatwg-fetch";
// ---------------------------------------------------------

import React from "react";
import ReactDOM from "react-dom";
import App from "./components/App";

import { runWithAdal } from './helpers/react-adal/react-adal';
import { authContext } from './adalConfig';

const DO_NOT_LOGIN = false;


//debugger;


require('./indexApp.js');

//runWithAdal(authContext, () => {

//    // eslint-disable-next-line
//    require('./indexApp.js');

//}, DO_NOT_LOGIN);